// Where a category route should send the customer instead of rendering its
// product list.
import { createSelector } from 'reselect';
import {
  getProductLink,
  LinkableProduct,
} from '../components/v3/shared/ProductLink';
import { isParentProduct } from '../utils/misc';

// The slice of a shoot_products category this selector reads.
export interface CatalogCategory {
  id: number | string;
  category_type?: string;
  products?: LinkableProduct[];
}

export interface CategoryRedirectState {
  shoot?: { shootProducts?: CatalogCategory[] };
}

// A category led by a parent product is a package, not a list: go straight to
// that product's config (the slot flow for you-pick / build-your-own, the
// regular config for multi-config). null when the category renders normally.
//
// Category reads this during render. It used to decide from a useEffect, which
// runs a commit after the product list has rendered — and a tap on the parent's
// tile in that commit opened the regular product config, which adds a
// you-pick / build-your-own package with no items chosen (ENG-1683).
export const selectCategoryRedirectPath = createSelector(
  [
    (state: CategoryRedirectState) => state.shoot?.shootProducts,
    (_state: CategoryRedirectState, categoryId: string) => categoryId,
  ],
  (shootProducts, categoryId): string | null => {
    const category =
      categoryId === 'nth-free'
        ? shootProducts?.find((cat) => cat.category_type === 'nth_free')
        : shootProducts?.find((cat) => String(cat.id) === categoryId);
    const leadingProduct = category?.products?.[0];

    return leadingProduct && isParentProduct(leadingProduct)
      ? getProductLink(leadingProduct)
      : null;
  },
);
